import React, { useState } from "react";
import "../css/navbar.css";
import Winners from "../winners";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const redirectTo = (input) => {
    window.location.href = input;
  };

  const token = sessionStorage.getItem("token");

  return (
    <>
      <nav className="navigation">
        <a href="/" className="brand-name">
          <img
            src="/images/uv_games_logo.png?v=1"
            alt="UV Games Logo"
            className="img-logo"
          />
        </a>
        <div>
          {/* {!!token && ( */}
          <div className="mobile-icons">
            {/*
              <button className="mobile-android-button winners_button"
                onClick={() => navigate('/allGames/Android')}>
                <i className="fa fa-android"></i>
              </button>
              */}
            {/*className="mobile-winner-button winners_button" 
              <i className="fa-solid fa-trophy"></i> 
              */}
            {!!token ? (
              <button
                className="mobile-winner-button winners_button"
                onClick={openModal}
              >
                Leaderboard
              </button>
            ) : (
              <button
                className="mobile-winner-button winners_button"
                onClick={() => redirectTo("/login")}
              >
                Login
              </button>
            )}
          </div>

          {/* )} */}
          <button
            className="hamburger"
            onClick={() => {
              setIsNavExpanded(!isNavExpanded);
            }}
          >
            <i className="fa-solid fa-bars"></i>
          </button>
        </div>

        <div
          className={
            isNavExpanded ? "navigation-menu expanded" : "navigation-menu"
          }
        >
          <ul>
            <li>
              <a href="/allGames/Sports">Sports</a>
            </li>
            <li>
              <a href="/allGames/Funny">Funny</a>
            </li>
            <li>
              <a href="/allGames/Action">Action</a>
            </li>
            <li>
              <a href="/allGames/Adventure">Adventure</a>
            </li>
            <li>
              <a href="/allGames/Racing">Racing</a>
            </li>
            <li>
              <a href="/allGames/Kids">Kids</a>
            </li>
            <li>
              <a href="/allGames/Puzzle">Puzzle</a>
            </li>
            <li className="mobile-category">
              <a href="/allGames/Android">Android Games</a>
            </li>
            <>
              {/*
                <li>
                  
                    <button className="winners_button tabletdesktop-winner-button" onClick={() => navigate('/allGames/Android')}>
                      <i className="fa fa-android"></i> Android Games
                    </button>
                </li>
                */}

              {!!token ? (
                <>
                  <li>
                    <button
                      className="winners_button tabletdesktop-winner-button"
                      onClick={openModal}
                    >
                      <i className="fa-solid fa-trophy"></i> Leaderboard
                    </button>
                  </li>
                  <li>
                    <button
                      className="logout_button tabletdesktop-logout-button"
                      onClick={() => redirectTo("/register")}
                    >
                      <i className="fas fa-house"></i>
                    </button>
                  </li>
                </>
              ) : (
                <li>
                  <button
                    className="logout_button tabletdesktop-logout-button"
                    onClick={() => redirectTo("/login")}
                  >
                    <i className="fas fa-sign-out"></i> Login
                  </button>
                </li>
              )}
            </>
          </ul>
        </div>
      </nav>
      {/* {!!token && <Winners isOpen={isOpen} closeModal={closeModal} />} */}
      <Winners isOpen={isOpen} closeModal={closeModal} />
    </>
  );
};

export default Navbar;
